import PerfectScrollbar from 'perfect-scrollbar/dist/perfect-scrollbar.js'

export { PerfectScrollbar }
